import '@arpm/ui/fonts.css';
import '@arpm/ui/tokens.css';
import '@arpm/ui/styles';
// Тема кабинета — ПОСЛЕ стилей дизайн-системы: собранный css пакета
// переопределяет часть токенов, и импорт раньше него не имел бы эффекта.
import './styles/theme.css';
import './styles/global.css';

import { VueQueryPlugin } from '@tanstack/vue-query';
import * as Sentry from '@sentry/vue';
import { createPinia } from 'pinia';
import { createApp } from 'vue';

import App from './App.vue';
import { i18n } from './i18n/index.js';
import { router } from './router/index.js';
import { useAuthStore } from './stores/auth.js';

async function bootstrap() {
  const app = createApp(App);

  // Sentry — подключаем до router и других плагинов, чтобы ловить их ошибки
  if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
      app,
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.MODE,
      release: import.meta.env.VITE_APP_VERSION,
      integrations: [Sentry.browserTracingIntegration({ router })],
      tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    });
  }

  app.use(createPinia());
  app.use(VueQueryPlugin, {
    queryClientConfig: {
      defaultOptions: {
        queries: {
          staleTime: 30_000,
          retry: 1,
          refetchOnWindowFocus: false,
        },
      },
    },
  });
  app.use(i18n);

  // Восстанавливаем сессию из storage до того, как router решит, куда вести
  const authStore = useAuthStore();
  await authStore.initialize();

  app.use(router);
  app.mount('#app');
}

bootstrap().catch((err) => {
  // eslint-disable-next-line no-console
  console.error('Не удалось загрузить приложение', err);
});
